export default __webpack_public_path__ + "static/outdoor_signage-c33bcdbcf425ae8b87c38792355faf57.png";